// app/src/lib/topup.jsx — a SHELL-LEVEL top-up surface. The out-of-credits gate (Script) and the
// out-of-credits banner (App) both need a WORKING top-up entry at any width and from any route —
// but the account sheet only lives on the rail (desktop) / create-home (mobile). This provider
// renders ONE shared top-up sheet over everything and exposes openTopUp() so a dead-end gate never
// happens (D1 credits contract §5.3). The pack list is the same TopUpList the account menu uses.

import React, { createContext, useContext, useState, useCallback } from 'react';
import { Sheet } from '../components/Sheet.jsx';
import { TopUpList } from '../components/AccountFoot.jsx';
import { useI18n } from '../i18n/index.jsx';

const TopUpCtx = createContext(() => {});

export function TopUpProvider({ children }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const openTopUp = useCallback(() => setOpen(true), []);
  return (
    <TopUpCtx.Provider value={openTopUp}>
      {children}
      <Sheet open={open} onClose={() => setOpen(false)} title={t('account.topUpMenu')}>
        <TopUpList />
      </Sheet>
    </TopUpCtx.Provider>
  );
}

export function useTopUp() {
  return useContext(TopUpCtx);
}
